import React from "react";

interface CustomerContactInfoProps {
  title: string;
  value: string;
  mt?: string;
}
export const CustomerContactInfo: React.FC<CustomerContactInfoProps> = ({ title, value, mt = '' }) => (
  <>
  <h3
  className={`font-normal not-italic text-[#000000] lg:text-[16px] text-[11px] leading-6 tracking-wide ${mt}`}
  style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
>
  {title}
</h3>
<p
  className="font-semibold not-italic text-[#000000] lg:text-[16px] text-[11px] md:text-[14px] leading-6 tracking-wide"
  style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
>
  {value}
</p>

  </>
);